import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { Helper } from "../../core/util/helper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import EditCalendar, { EditCalendarProps, CalendarEntity } from "./editCalendar";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { TextBox, TextBoxProps } from "../../core/components/textBox";
import { CheckBox, CheckBoxProps } from "../../core/components/checkBox";
import { DatePicker, DatePickerProps } from "../../core/components/datePicker";
import { ComponentHelper } from "../../core/util/componentHelper";
import { FieldInstance } from "../../core/components/field";
import { FullHeightContainer } from "../../core/components/FullHeighContainer";
import { Label } from "../../core/components/label";
import { Dialog, DialogProps } from "../../core/components/dialog";
import { DialogHelper } from "../../core/util/dialogHelper";
import { FAIcon } from "../../core/components/faIcon";
import EditTranslations from ".././editTranslations";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { Metadata } from "../../core/components/commonApp";
import React from "react"

export default class EditCalendarGrid extends React.Component<EditCalendarGridProps, EditCalendarGridState> {
    private _specialCalandarActivated = true;

    constructor(props) {
        super(props);
        this._specialCalandarActivated = this.props.entity.GeneralSettings.SpezialkalenderAktiviert;
    }

    private _getGridComponent = () => {
        if (this._specialCalandarActivated) {
            return (
                <EditSpecialCalanderGrid {...this.props} />
            );
        } else {
            return (
                <EditStandardCalendarGrid {...this.props} />
            );
        }
    }

    render() {
        const grid = this._getGridComponent();
        return (
            <>
                {grid}
            </>
        );
    }
};

class EditSpecialCalanderGrid extends React.Component<EditCalendarGridProps, EditCalendarGridState> {
    constructor(props) {
        super(props);
        this.state = {
            gridData: [],
            enableDeleteButton: false,
            loadingState: "loaded"
        };
    }

    private getGridData = () => {
        this.setState({ loadingState: "loading" }, async () => {
            const url = "Calendar/GetAllCalendars";
            const result = await HTTPService.noBusyIndicator().get<JsonResultClass>(url);
            this.setState({
                gridData: result.Data, loadingState: "loaded" });
        })
    }

    private openCalender = async (dataItem: CalendarEntity = null) => {
        let entityURL = "Calendar/GetCalendar";
        if (Helper.hasValue(dataItem)) {
            entityURL += "?id=" + dataItem.Id;
        }
        const [dataResult, metaData] = await Promise.all([
            HTTPService.get<JsonResultClass>(entityURL),
            Helper.getMetaData("calendar")
        ])
        this.initCalenderWindow(dataResult.Data, metaData);
    }

    private initCalenderWindow = (entity: any, metaData: any) => {
        const props: EditCalendarProps = {
            dataSources: {}, metadata: metaData as Metadata, entity: entity, isWindow: true, context: {}, title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
            this.getGridData();
        });

        sheet.show(() => {
            sheet.mountContent(EditCalendar, props);
        });
    }

    private deleteCalender = async (id: number) => {

        const isOk = await DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]);
        if (isOk) {
            const result = await HTTPService.post<JsonResultClass>("Calendar/DeleteCalendar?id=" + id);
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(result.Message);
                this.getGridData();
            } else if (result.Code === 2) {
                NotificationHelper.showInfoMessage(result.Message);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    private handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: CalendarEntity) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this.openCalender(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this.openCalender();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this.deleteCalender(dataItem.Id);
        }
    }

    private createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton }
        ];

        const grid = (
            <Grid data={this.state.gridData} options={this.props.context.editSpecialCalendarGridOptions} id="calenderGrid"
                standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} onSelectionChanged={this.handleOnSelectionChanged} />
        );
        return (
            <div style={{ height: "300px" }}>
                {grid}
            </div>
        );
    }

    private handleOnSelectionChanged = (dataItem: CalendarEntity) => {
        if (Helper.hasValue(dataItem))
            this.setState({ enableDeleteButton: dataItem.IsDeletable });
    }

    componentDidMount() {
        this.getGridData();
    }

    render() {
        if (this.state.loadingState == "loading") {
            return (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "200px" }}>
                    <FAIcon name="spinner" prefix={"fas"} spins={true} attributes={["spin", "3x"]}/>
                </div>
           );
        } else {
            const grid = this.createGrid();
            return (
                <div style={{ height: "100%", width: "100%" }}>
                    <div className="flex-container flex-container__item" style={{ height: "300px" }}>
                        {grid}
                    </div>
                </div>
            );
        }
    }
}

class EditStandardCalendarGrid extends React.Component<EditCalendarGridProps, EditStandardCalendarGridState> {

    private _factory = ComponentHelper.createFactory();
    private _editTranslationsRef: EditTranslations = null;
    private _translations: {};
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._save();
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.setState({ dialogOpen: false });
        },
        width: 500
    };
    constructor(props) {
        super(props);
        const thisYear = new Date().getFullYear();
        const startDate = thisYear + '-01-01T00:00:00';
        const endDate = (thisYear + 1) + '-01-01T00:00:00';
        this._translations = this.props.context.translations;
        this.state = {
            gridData: [], searchParameters: { startDate: new Date(startDate), endDate: new Date(endDate) }, dialogOpen: false, selectedItem: null
        }
    }

    private _save = () => {
        let url = "Calendar/SaveStandardCalender";
        HTTPService.post<HTTPGetResultData>(url, this.state.selectedItem).then(result => {
            if (result.Code != 0) {
                NotificationHelper.showErrorMessage(result.Message);
            } else {
                this._getGridData();
            }
        });
    }

    private _delete = (dataItem: StandartCalendarEntity) => {
        DialogHelper.confirm(this.props.context.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>("Calendar/DeleteStandartdCalendar?id=" + dataItem.Id)
                    .then(result => {
                        if (result.Code === 0) {
                            this._getGridData();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    private _getGridData = () => {
        let url = "Calendar/GetAllStandartCalender?startDate=" + Helper.getValueOrDefault(Helper.dates.getISODateString(this.state.searchParameters.startDate), "null") + "&endDate=" + Helper.getValueOrDefault(Helper.dates.getISODateString(this.state.searchParameters.endDate), "null");
        HTTPService.get<HTTPGetResultData>(url).then(result => {
            this.setState({ gridData: result.Data });
        });
    }

    private _createSearchParameters = () => {
        return (
            <>
                {this._labelPeriod()}
                {this._createDateTimePickerForSearch("start")}
                {this._createDateTimePickerForSearch("end")}
            </>);
    }

    private _labelPeriod = () => {
        let props = this._factory.getDefaultLabelProps();
        props.value = this._translations["WebSMS.GeneralSettings.Calender.Period"] + " :";

        return (
            <div style={{ marginLeft: "6px", fontSize:"18px" }}>
                <Label {...props} />
            </div>
            );
    }

    private _createDateTimePickerForSearch = (value: "start" | "end") => {
        let props = this._factory.getDefaultDatePickerProps();
        let label: string = "";
        switch (value) {
            case ("start"):
                label = this._translations["WebSMS.GeneralSettings.Calender.from"]
                props.value = this.state.searchParameters.startDate;
                props.onChange = (field: { model: string, name: string }, value: any) => {
                    let searchParameter = this.state.searchParameters;
                    searchParameter.startDate = Helper.getValueOrDefault(value, this.state.searchParameters.startDate);
                    this.setState({ searchParameters: searchParameter });
                    this._getGridData();
                }
                break;
            case ("end"):
                props.value = this.state.searchParameters.endDate;
                label = this._translations["WebSMS.GeneralSettings.Calender.to"];
                props.onChange = (field: { model: string, name: string }, value: any) => {
                    let searchParameter = this.state.searchParameters;
                    searchParameter.endDate = Helper.getValueOrDefault(value, this.state.searchParameters.endDate);
                    this.setState({ searchParameters: searchParameter });
                    this._getGridData();
                }
                break;
        }
        return (
            <div style={{ width: "50%" }}>
                <FieldInstance label={label} noHover={true}>
                    <DatePicker {...props} />
                </FieldInstance>
            </div>
        );
    }

    private _createDialog = () => {
        return (
            <div>
                <Dialog {...this._dialogProps} open={this.state.dialogOpen} >
                    <FullHeightContainer>
                        {this._createNameTextBox()}
                        {this._createDateTimePicker()}
                        {this._createCheckBox()}
                    </FullHeightContainer>
                </Dialog>
            </div>
        );
    }

    private _createDateTimePicker = () => {
        let props: DatePickerProps = this._factory.getDefaultDatePickerProps();
        if (Helper.hasValue(this.state.selectedItem))
            props.value = Helper.dates.toDate(Helper.dates.getISODateString(this.state.selectedItem.Date));
        props.disabled = !this.state.selectedItem.IsNew;
        props.onChange = (field: { model: string, name: string }, value: any) => {
            let newSelectedItem = this.state.selectedItem;
            newSelectedItem.Date = Helper.dates.toDate(Helper.dates.getISODateString(value));
            this.setState({ selectedItem: newSelectedItem });
        };
        return (
            <FieldInstance label={this._translations["WebSMS.GeneralSettings.Calender.Date"]} noHover={true}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    private _createNameTextBox = () => {
        let props: TextBoxProps = this._factory.getDefaultTextBoxProps();
        if (Helper.hasValue(this.state.selectedItem)) {
            props.value = Helper.getValueOrDefault(this.state.selectedItem.Name, "");
        }
        props.field.maxLength = 33;
        props.onChange = (field: { model: string, name: string }, value: any) => {
            let newSelectedItem = this.state.selectedItem;
            newSelectedItem.Name = value;
            this.setState({ selectedItem: newSelectedItem });
        }
        return (
            <>
                <FieldInstance label={this._translations["Standard.Name"]} noHover={true}>
                    <TextBox {...props} />
                </FieldInstance>
                <EditTranslations
                    ref={(r) => this._editTranslationsRef = r}
                    label={Config.translations.editLabel}
                    saveGerman={(value: string) => {
                        let newSelectedItem = this.state.selectedItem;
                        newSelectedItem.GermanName = value;
                        this.setState({ selectedItem: newSelectedItem });
                    }}
                />
                {this._translationsLabel()}
            </>
        );
    }

    private _translationsLabel = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline",
            display: this.state.selectedItem.IsNew ? "none" : "block"
        }
        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }

        return (
            <FieldInstance noLabel={true}>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={() => {
                        this._editTranslationsRef.openDialog(this.state.selectedItem.Id, 115, "value_0", this.state.selectedItem.GermanName);
                    }}>{this.props.context.translations["WebSMS.GeneralSettings.UebersetzungenBearbeiten"]}</label>
                </div>
            </FieldInstance>
        );

    }

    private _createCheckBox = () => {
        let props: CheckBoxProps = this._factory.getDefaultCheckBoxProps();
        if (Helper.hasValue(this.state.selectedItem)) {
            props.value = this.state.selectedItem.HalfWorkingDay;
        }
        props.onChange = (_, value: any) => {
            let newSelectedItem = this.state.selectedItem;
            newSelectedItem.HalfWorkingDay = value;
            this.setState({ selectedItem: newSelectedItem });
        }
        return (
            <FieldInstance label={this._translations["WebSMS.GeneralSettings.Calender.HalfWorkingDay"]} noHover={true}>
                <CheckBox {...props} />
            </FieldInstance>
        );
    }

    private _openDialog = (dataItem: StandartCalendarEntity = null) => {
        let url = "Calendar/GetStandartCalender";
        if (Helper.hasValue(dataItem)) {
            url += "?id=" + dataItem.Id;
        }
        HTTPService.get<HTTPGetResultData>(url).then(result => {
            this.setState({
                selectedItem: result.Data, dialogOpen: true
            });
        });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: StandartCalendarEntity) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this._openDialog(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this._openDialog();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._delete(dataItem);
        }
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true });
        let grid = (
            <Grid data={this.state.gridData} options={this.props.context.editStandardCalendarGridOptions} id="calenderGrid"
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton} />
        );
        return (
            <div style={{ height: "300px" }}>
                {grid}
            </div>
        )
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const searchParameters = this._createSearchParameters();
        const grid = this._createGrid();
        const dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <>
                {searchParameters}
                {grid}
                {dialog}
            </>
        );
    }
}

interface EditCalendarGridState {
    gridData: CalendarEntity[];
    enableDeleteButton: boolean;
    loadingState: 'loaded'| 'loading'
}

interface EditCalendarGridProps {
    context: ContextGeneralSettingsApp;
    entity: any;
}

interface HTTPGetResultData {
    Code?: number;
    Message?: string;
    Data?: any;
}

interface EditStandardCalendarGridState {
    searchParameters: {
        startDate: Date;
        endDate: Date;
    };
    gridData: StandartCalendarEntity[];
    dialogOpen: boolean;
    selectedItem: StandartCalendarEntity;
}

interface StandartCalendarEntity {
    Id: number;
    Date: Date;
    Name: string;
    GermanName: string;
    HalfWorkingDay: boolean;
    IsNew: boolean;
}



